import * as React from "react";
import {connect} from "react-redux";
import {Row, Col} from "antd";

import {VideoPlayer} from "../../components/video-player";
import {RootState} from "../../reducers";
import "./styles.less";
import "video.js/dist/video-js.css";

interface Props {
  name: string;
  stream: string;
}

class HomeContainerComponent extends React.Component<Props, {}> {
  render() {
    return (
      <Row>
        <Col span={24}>
          <div className="video-container">
            <div className="dear-name">
              Dear {this.props.name},
            </div>

            <div className="video" data-vjs-player>
              <VideoPlayer
                poster="https://d2470ex6rqt2tc.cloudfront.net/thumbnails/generic/generic-00010.jpg"
                url={this.props.stream}
                className="video-player"
              />
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  name: state.user.name,
  stream: state.user.stream,
});

export const HomeContainer = connect(mapStateToProps)(HomeContainerComponent);



// WEBPACK FOOTER //
// ./src/containers/home/index.tsx